module.exports = __webpack_public_path__ + "img/cartao.da58bb85.png";